import React from 'react';
import { NextSeo } from 'next-seo';
import { connect } from 'react-redux';
import IndexLayout from '~/components/Layouts/IndexLayout/IndexLayout';
import DueDateFilter from '~/components/index/DueDateFilter/DueDateFilter';
import YuesaoFeed from '~/components/index/YuesaoFeed/YuesaoFeed';

// eslint-disable-next-line
const HomeUpgrade = () => {
  return (
    <p
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundImage: 'url("https://weapp-assets.xindebaby.com/web-upgrading-210726.png")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    />
  );
};

const Home = ({ dispatch }) => {
  const handleDueDateSubmit = React.useCallback(
    ({ year, month, day }) => {
      const formattedMonth = String(month).padStart(2, '0');
      const formattedDay = String(day).padStart(2, '0');
      const expectedBirthDate = `${year}-${formattedMonth}-${formattedDay}`;
      dispatch({
        type: 'index/getYuesaoRecommendations',
        payload: {
          due_date: expectedBirthDate,
          days: 26,
        },
      });
    },
    [dispatch],
  );

  return (
    <IndexLayout>
      <NextSeo
        title="新得宝贝 - 专业母婴护理机构"
        description="MUA孕育守护是新得宝贝旗下的孕产服务优选平台。帮助孕期及产后的妈妈优选私立医院、月子会所、月嫂、孕期摄影、新生儿摄影、产后修复、亲子游泳、早教等孕产服务。"
        additionalMetaTags={[
          {
            name: 'keywords',
            content:
              '新得宝贝,MUA孕育守护,北京建档,北京月嫂,北京育儿嫂,北京私立医院,北京产后修复,北京亲子游泳,北京儿童摄影,北京早教,北京怀孕',
          },
        ]}
      />
      <DueDateFilter onSubmit={handleDueDateSubmit} />
      <YuesaoFeed />
    </IndexLayout>
  );
};

Home.getInitialProps = async ({ pathname, query, dvaStore }) => {
  await dvaStore.dispatch({ type: 'index/getYuesaoRecommendations' });
  return {
    pathname,
    query,
    dvaStore,
  };
};

export default connect(({ index }) => ({ index }))(Home);
